module.exports = __webpack_public_path__ + "img/d930cf8.jpg";